// extracted by mini-css-extract-plugin
export default {"services":"services_services__i6s7D","newsService":"services_newsService__3Bwfa"};